<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'status'"
            v-model="formulario.status"
            :placeholder="'Nome do Status'"
            data-vv-as="Nome do Status"
            v-validate="'required|max:255'"
            :error="validationErrors.first('status')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioCtrlStatusComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    ctrlStatus: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formulario: {
        id: this.ctrlStatus.id || null,
        status: this.ctrlStatus.status || '',
      }
    }
  },

  methods: {
    ...mapActions('ctrlStatus', ['salvarCtrlStatus', 'atualizarCtrlStatus']),

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      if (this.tipoFormulario === 'salvar') {
        await this.salvarCtrlStatus(this.formulario)
      } else {
        await this.atualizarCtrlStatus(this.formulario)
      }

      this.limparCampos()
      this.fecharModal()
    },

    limparCampos () {
      this.formulario = {
        status: '',
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$emit('fechar')
    }
  }
}
</script>
